import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module-react';

import './Editor.css';

Quill.register('modules/imageResize', ImageResize);

const modules = {
    toolbar: [
        [{ header: [] }],
        [{ align: [] }], // Text alignment options
        ["bold", "italic", "underline", "strike"],
        ["image", "link"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
    ],
    imageResize: {
        // optional: specify resize options here
        parchment: Quill.import("parchment"),
    }
};

// List of formats to enable
const formats = [
  "header",
  "align",
  "bold",
  "italic",
  "underline",
  "strike",
  "image",
  "link",
  "list",
  "bullet",
];


function Editor({ value, onChange }) {
    window.Quill = Quill; // Ensure Quill is globally accessible
    return <ReactQuill className="editorContainer" formats={formats} modules={modules} value={value} onChange={onChange} />;
}
export default Editor;